export default __webpack_public_path__ + "static/media/liel-kaizer.fbb14f0d.png";